import { supabase } from "@/integrations/supabase/client";
import { firstTouch } from "./acquisition";

/**
 * Save a new account's first-touch source (`acquisition.ts`) as its row in
 * `account_acquisition`, called once at sign-up. The browser names only the
 * source's columns: `user_id` defaults to the caller's, and the grant covers
 * nothing else.
 *
 * A guest buyer's account already has its row, written by `stripe-webhook`
 * from the checkout, so this insert finds it taken (23505) and leaves it.
 * Analytics: a failure is logged, never shown.
 */
export async function saveAccountAcquisition(): Promise<void> {
  const touch = firstTouch();
  if (!touch) return;
  try {
    const { error } = await supabase.from("account_acquisition").insert(touch);
    if (error && error.code !== "23505") console.warn("Acquisition not recorded:", error.message);
  } catch (err) {
    console.warn("Acquisition not recorded:", err);
  }
}
